// src/context/GameContext.js - Updated to work with TSO Auth
import React, { createContext, useContext, useReducer, useEffect } from 'react';
import { useAuth } from './AuthContext.tsx';

// Initial state
const initialState = {
  user: null,
  profile: null,
  // Add any other game state you want to track globally
};

// Reducer function
function gameReducer(state, action) {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload };
    case 'SET_PROFILE':
      return { ...state, profile: action.payload };
    // Add other action handlers as needed
    default:
      return state;
  }
}

// Create context
const GameContext = createContext();

// Provider component
export function GameProvider({ children }) {
  const [state, dispatch] = useReducer(gameReducer, initialState);
  const { user, profile } = useAuth();
  
  // Sync auth state with game context
  useEffect(() => {
    dispatch({ type: 'SET_USER', payload: user });
  }, [user]);
  
  useEffect(() => {
    dispatch({ type: 'SET_PROFILE', payload: profile });
  }, [profile]);
  
  return (
    <GameContext.Provider value={{ state, dispatch }}>
      {children}
    </GameContext.Provider>
  );
}

// Custom hook for using the context
export function useGame() {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
}